import React from "react";
import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./routes/app-routes.tsx";
import { AppProvider } from "./context/app-context.tsx";

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AppProvider>
  );
}

export default App;
